import { Directive, OnDestroy } from '@angular/core';
import { Observable, PartialObserver, Subscription } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';

@Directive()
export abstract class SubscriptionBasedComponent implements OnDestroy {
  private subscriptions: Subscription[] = [];

  protected addSubscription(
    observable: Observable<any>,
    successCallback: (any) => void,
    errorCallback?: (any) => void,
    time?: number
  ): Subscription {
    const observer: PartialObserver<any> = {
      next: successCallback,
      error: errorCallback,
      //complete can be added if needed.
    };

    const subscription =
      time != null
        ? observable.pipe(debounceTime(time)).subscribe(observer)
        : observable.subscribe(observer);

    this.subscriptions.push(subscription);
    return subscription;
  }

  protected addSubscriptionSwitchMap(
    observable: Observable<any>,
    pipe: (any) => any,
    successCallback: (any) => void
  ): void {
    const subscription = observable
      .pipe(switchMap(pipe))
      .subscribe(successCallback);

    this.subscriptions.push(subscription);
  }

  protected destroySubscription(subscription: Subscription): void {
    const index = this.subscriptions.findIndex((s) => (s = subscription));
    this.subscriptions.splice(index, 1);
    subscription.unsubscribe();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }
}
